import { Grid } from '@mui/material';
import { useSubmotive2Filters } from './hook';
import { Submotive2FiltersProps } from './props';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import MultipleAutocompleteField from '../../../../components/general/fields/multipleAutocompleteField';

export const Submotive2Filters = ({
    onFilter,
    loading,
}: Submotive2FiltersProps) => {
    const { formik, types, motives, submotives1 } =
        useSubmotive2Filters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={types}
                    label="Tipo PQR"
                    name="nestedParent2"
                    size="small"
                    touched={formik.touched.nestedParent2}
                    errors={formik.errors.nestedParent2}
                    value={formik.values.nestedParent2}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.name
                        );
                        formik.setFieldValue('nestedParent2', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={motives}
                    label="Motivo"
                    name="nestedParent"
                    size="small"
                    touched={formik.touched.nestedParent}
                    errors={formik.errors.nestedParent}
                    value={formik.values.nestedParent}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.name
                        );
                        formik.setFieldValue('nestedParent', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={submotives1}
                    label="Submotivo 1"
                    name="parent"
                    size="small"
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.name
                        );
                        formik.setFieldValue('parent', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
